import {
  Box,
} from '@mui/material';
import { useEffect } from 'react';
import { InputLimits } from '../../../../enums/InputLimits';

function PageSetting(props: {
  smartPhoneWidth?: number,
  deskTopWidth?: number,
  onSmartPhoneWidthChange: (value: number) => void,
  onDeskTopWidthChange: (value: number) => void,
}) {
  const {
    smartPhoneWidth,
    deskTopWidth,
    onSmartPhoneWidthChange,
    onDeskTopWidthChange,
  } = props;
  const defaultDesktopWidth = 1920;
  const defaultSmartPhoneWidth = 1400;

  useEffect(() => {
    if (!smartPhoneWidth) {
      onSmartPhoneWidthChange(defaultSmartPhoneWidth);
    }
    if (!deskTopWidth) {
      onDeskTopWidthChange(defaultDesktopWidth);
    }
  });

  return (
    <Box display="flex" flexDirection="column" rowGap="10px">
      <Box>
        <div className="col-form-label text-bold">Page Width</div>
        <p className="mb-2">Set the default width for export.</p>
      </Box>

      <div className="pb-2">
        <div className="row my-3">
          <div className="col-12">
            <div className="text-bold mb-2">Desktop (from 1400px)</div>
            <input
              type="number"
              className="form-control mb-1"
              placeholder=""
              max={InputLimits.NUMBER_LIMIT}
              value={smartPhoneWidth || defaultSmartPhoneWidth}
              onChange={(e) => {
                onSmartPhoneWidthChange(parseInt(e.target.value, 10));
              }}
              inputMode="numeric"
              pattern="[0-9]*"
            />
            <div className="text-sm">*Enter value in pixels (px).</div>
          </div>
        </div>

        <div className="row my-3">
          <div className="col-12">
            <div className="text-bold mb-2">Wide Desktop (from 1920px)</div>
            <input
              type="number"
              className="form-control mb-1"
              placeholder=""
              max={InputLimits.NUMBER_LIMIT}
              value={deskTopWidth || defaultDesktopWidth}
              onChange={(e) => {
                onDeskTopWidthChange(parseInt(e.target.value, 10));
              }}
              inputMode="numeric"
              pattern="[0-9]*"
            />
            <div className="text-sm">*Enter value in pixels (px).</div>
          </div>
        </div>
      </div>
    </Box>
  );
}

export default PageSetting;
